import { Button, Space, Typography } from "antd"
import ErrorLayout from "modules/layout/error"
import { ReactComponent as RefreshIcon } from "assets/icons/refresh.svg"
import { useTranslation } from "react-i18next"

interface Props {
  reset(): void
}

const { Link } = Typography

const UnexpectedError: React.FC<Props> = ({ reset }) => {
  const { t } = useTranslation()
  return (
    <ErrorLayout>
      <ErrorLayout.Icon />
      <ErrorLayout.Error>
        {t("errors.unexpected_error.title")}
      </ErrorLayout.Error>
      <ErrorLayout.Title>
        {t("errors.unexpected_error.sub_title")}
      </ErrorLayout.Title>
      <ErrorLayout.Subtitle>
        {t("errors.unexpected_error.message")}{" "}
        <Link
          target="_blank"
          href="mailto:support@amalyet.com"
          rel="noreferrer"
        >
          support@amalyet.com
        </Link>
        .
      </ErrorLayout.Subtitle>
      <ErrorLayout.Actions>
        <Button size="large" type="primary" onClick={reset}>
          <Space align="center">
            <RefreshIcon />
            {t("errors.unexpected_error.try_again")}
          </Space>
        </Button>
      </ErrorLayout.Actions>
    </ErrorLayout>
  )
}

export default UnexpectedError
